import { render, staticRenderFns } from "./ThreatsTabs.vue?vue&type=template&id=6d259fac&"
import script from "./ThreatsTabs.vue?vue&type=script&lang=js&"
export * from "./ThreatsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports